import instance from '../globals/axios';
import { isNotNullOrEmptyArray } from '../globals/utils';

export const getCommodities = async type => {
  let url = 'common/commodities/';
  if (type) {
    url = `common/commodities/?type=${type}`;
  }
  const response = await instance.get(url);
  return response.data;
};

export const getLocationDetailsFromPincode = async pincode => {
  const response = await instance.get(`common/pincode/${pincode}`);
  const response_data = response.data[0];
  if (isNotNullOrEmptyArray(response_data.PostOffice)) {
    const { State, District } = response_data.PostOffice[0];
    const postOffices = response_data.PostOffice.map(
      postOffice => postOffice.Name
    );
    const locationDetails = {
      pincode: pincode,
      state: State,
      district: District,
      postOffices: postOffices,
    };
    return locationDetails;
  }
  throw new Error('No data found for the given pincode');
};

export const getWeatherForecast = async (lat, lon) => {
  const cacheKey = 'weatherForecast';
  const cachedData = JSON.parse(localStorage.getItem(cacheKey));
  const now = Date.now();
  const CACHE_EXPIRY = 15 * 60 * 1000; // 15 minutes in milliseconds

  if (cachedData && cachedData.timestamp > now - CACHE_EXPIRY) {
    return cachedData.data;
  }

  try {
    const response = await instance.get('alerts/get-weather-and-forecast/', {
      params: { lat, lon },
    });
    if (!response || !response.data || !response.data.data) {
      throw new Error('No data found for the given coordinates');
    }
    const data = response.data.data;
    localStorage.setItem(cacheKey, JSON.stringify({ data, timestamp: now }));
    return data;
  } catch (error) {
    console.error('Error fetching weather forecast:', error);
  }
};

export const getWeatherAlerts = async (lat, lon, lang) => {
  try {
    const response = await instance.get('alerts/get-weather-alerts/', {
      params: {
        lat,
        lon,
        lang,
      },
    });

    if (!response || !response.data || !response.data.data) {
      throw new Error('No data found for the given coordinates');
    }

    const data = response.data.data;
    return data;
  } catch (error) {
    console.error('Error fetching weather alerts:', error);
  }
};
